<div class="row files-upload">
    <div class="col-12">
        <ng-container *ngTemplateOutlet="uploadFiles"></ng-container>
    </div>
</div>
<div class="row files-list">
    <div class="col-12">
        <ng-container *ngTemplateOutlet="fileList; context: {files : Files}"></ng-container>
    </div>
</div>


<ng-template #uploadFiles>
    <div class="dropzone" appDragDrop (fileDropped)="onFilesDrop($event)" (change)="onFilesChange($event.target.files)">
        <input type="file" #fileDropRef id="fileDropRef" multiple hidden [accept]="accept"/>
        <label for="fileDropRef">
            <span class="material-icons">
                cloud_upload
            </span>
        </label>
    </div>
</ng-template>

<ng-template #fileList let-state="files">
    <div class="row file-info" *ngFor="let file of Files; let i = index">
        <div class="col-auto mr-auto name">{{file.name}} <i>({{file.size | fileSize }})</i></div>
        <div class="col-auto delete-icon">
            <span class="material-icons" (click)="onDeleteFile(i)">
                delete_forever
            </span>
        </div>
    </div>
</ng-template>